/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import RotatingCard from "examples/Cards/RotatingLogo";
import RotatingCardFront from "examples/Cards/RotatingLogo/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingLogo/RotatingCardBack";

import whatsappIcon from "assets/images/whatsapp.png";

function DefaultFooter({ content }) {
  const { brand, copyright } = content;

  return (
    <MKBox component="footer">
      <Container>
        <Grid container spacing={3}>
          <Grid id="contact" item xs={12} md={12} sx={{ mb: 6 }}>
            <MKTypography variant="h1">CONTACT US!</MKTypography>

            <MKBox
              mt={3}
              position="relative"
              display="flex"
              justifyContent="right"
              alignContent="center"
              alignItems="center"
              borderRadius="lg"
              width="100%"
              component="a"
              href="http://wa.me/6586936811"
              target="_blank"
            >
              <RotatingCard>
                <RotatingCardFront
                  color="light"
                  title={
                    <>
                      <MKBox component="img" src={whatsappIcon} width="70px" />
                    </>
                  }
                />
                <RotatingCardBack
                  color="light"
                  title={
                    <>
                      <MKBox component="img" src={whatsappIcon} width="70px" />
                    </>
                  }
                />
              </RotatingCard>
              <MKBox
                ml={4}
                p={4}
                minWidth="40%"
                borderRadius="25px"
                bgColor="white"
                coloredShadow="info"
                component="a"
                href="http://wa.me/6586936811"
                target="_blank"
                textAlign="center"
              >
                <MKTypography variant="h4">WhatsApp Now</MKTypography>
              </MKBox>
            </MKBox>
          </Grid>
          <Grid item xs={12} md={12} sx={{ ml: "auto", mb: 3 }}>
            <MKBox>
              {/* <Link to={brand.route}>
                <MKBox component="img" src={brand.image} alt={brand.name} maxWidth="2rem" mb={2} />
              </Link> */}
              <MKTypography variant="h6">{brand.name}</MKTypography>
              <MKTypography variant="body2">+65 8693 6811</MKTypography>
              <MKTypography variant="body2">10 Ubi Crescent, #03-12, Singapore 409564</MKTypography>
            </MKBox>
          </Grid>

          <Grid item xs={12} sx={{ textAlign: "center", my: 3 }}>
            {copyright}
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

// Typechecking props for the DefaultFooter
DefaultFooter.propTypes = {
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array])).isRequired,
};

export default DefaultFooter;
